import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonToggle, MatButtonToggleModule } from "@angular/material/button-toggle";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { TimeZoneT } from "src/app/constants/constants";
import { HourCycle, TimeZoneService } from "src/app/services/time-zone.service";
@Component({
    selector: "app-time-settings",
    templateUrl: "./time-settings.component.html",
    styleUrls: ["./time-settings.component.scss"],
    imports: [NgbDropdownModule, TranslateModule, FontAwesomeModule, NgSelectModule, FormsModule, MatButtonToggleModule]
})
export class TimeSettingsComponent {
    intl = Intl;
    orderedTimeZones: TimeZoneT[];
    timeZoneService = inject(TimeZoneService);

    constructor() {
        this.setTimeZoneOrder();
    }

    setTimeZoneOrder() {
        const mostRecentTimeZonesString: string = localStorage.getItem("recent.timeZones") ?? "";
        const mostRecentTimeZonesArray: string[] = mostRecentTimeZonesString.split(",").reverse();
        let timeZones = this.timeZoneService.timeZones;
        for (let i = 0, len = mostRecentTimeZonesArray.length; i < len; i++) {
            timeZones = this.moveToFirst(timeZones, "value", mostRecentTimeZonesArray[i]);
        }
        this.orderedTimeZones = [...timeZones];
    }

    moveToFirst(arr: TimeZoneT[], key: keyof TimeZoneT, value: string) {
        const arrayUpdated: TimeZoneT[] = [];
        arr.forEach(e => {
            if (e[key] === value) arrayUpdated.unshift(e);
            else arrayUpdated.push(e);
        });
        return arrayUpdated;
    }

    timeFormatChange(event: { source: MatButtonToggle; value: HourCycle }) {
        this.timeZoneService.setTimeFormat(event.value);
    }
}
